// 账户绑定
<template>
  <div class="bind-root" :style="cssVars">
    <div class="bind-box-sty" v-show="RENDER">
      <img :src="bindForm.icon || '/images/icon/sign-1.png'" alt="电子签约" />
      <h1>{{ bindForm.platformName || ''}}</h1>
      <el-form
        label-width="100px"
        :model="bindForm"
        :rules="bindRules"
        ref="bindFormRef"
        style="width: 30vw;"
      >
        <el-form-item label="账号：" prop="emailOrPhone">
          <el-input v-model="bindForm.emailOrPhone" :disabled="accountBind"></el-input>
        </el-form-item>
        <el-form-item label="验证码：" prop="valicode">
          <el-input v-model="bindForm.valicode">
            <el-button
              slot="append"
              :disabled="countdown > 0"
              @click="verifyHandle"
              :style="{'background-color': bindForm.btnColor,'border-color': bindForm.btnColor}"
            >{{countdown > 0 ? `${countdown} S` : '获取验证码'}}</el-button>
          </el-input>
        </el-form-item>
        <el-form-item style="text-align: center;">
          <el-button @click="submitForm('bindForm')" round class="comfirm-btn">确认授权</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 验证码实例 组件中有多处使用验证码，避免重复创建实例 -->
    <div v-show="false">
      <AliCaptcha
        :handCallback="countdownLe"
        :targetId="bindForm.emailOrPhone"
        :verifyType="BUSITYPE.ACCOUNTBIND"
      >
        <button ref="aliCaptchaRef">发送验证码</button>
      </AliCaptcha>
    </div>
  </div>
</template>

<script>
import { BUSITYPE } from "@/assets/js/utils/others";
// API
import { ApiMethods, checkTargetExists } from '@/assets/js/http-serve/http-methods'
// components
import AliCaptcha from '../../../components/send-auth-validcode/aliCaptchaNew.vue';
export default {
  layout: 'empty',
  components: { AliCaptcha },
  data () {
    // 这里存放数据
    return {
      bindForm: {
        emailOrPhone: '',
        valicode: ''
      },
      bindRules: {
        emailOrPhone: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        valicode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      accountBind: false,
      countdown: 0,
      BUSITYPE,
      loading: null,
      RENDER: false
    }
  },
  // 方法集合
  methods: {
    submitForm () {
      this.$refs.bindFormRef.validate().then((vaild) => {
        if (vaild) {
          const { sign, key, ts } = this.$route.query, { emailOrPhone, valicode } = this.bindForm;
          ApiMethods.AccountLoginController.anonyUserBind({ sign, key, ts, emailOrPhone, valicode }).then(res => {
            if (!res.success) return this.$message.error(res.description);
            if (res.data) window.location.href = res.data;
          })
        };
      })
    },
    /** 获取绑定信息 */
    getBindInfo () {
      this.loadingStart()
      this.RENDER = false
      const { sign, key, ts } = this.$route.query;
      ApiMethods.AccountLoginController.bindInfo({ sign, key, ts }).then(res => {
        if (!res.success) return this.$message.error(res.description);
        this.bindForm = { ...this.bindForm, ...res.data };
        this.accountBind = !!res.data.emailOrPhone;
      }).catch(err => {
        this.$message.error(err)
      }).finally(() => {
        this.loadingClose();
        this.RENDER = true
      })
    },
    /** 触发阿里验证 */
    verifyHandle () {
      this.$refs.bindFormRef.validateField('emailOrPhone', (err) => {
        if (!err) {
          // 获取到验证码组件ref
          const aliCaptchaRef = this.$refs.aliCaptchaRef
          // 触发验证码组件点击事件
          aliCaptchaRef.click()
        }
      })
    },
    /** 发送短信验证码倒计时 */
    countdownLe () {
      let interval = null
      this.countdown = 120
      interval = setInterval(() => {
        this.countdown--
        if (this.countdown === 0) clearInterval(interval)
      }, 1000)
    },
    loadingStart () {
      this.loadingClose();
      this.loading = this.$loading({
        lock: true
      });
    },
    loadingClose () {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.getBindInfo();
  },
  computed: {
    cssVars () {
      return {
        '--bind-color': this.bindForm.btnColor || '#ec1c1c'
      }
    }
  },
}
</script>

<style lang='less' scoped>
// @import url(); 引入公共css类
@boxWidth: 70vw;
.bind-root {
  .bind-box-sty {
    width: @boxWidth;
    height: 65vh;
    margin: 0 auto;
    background: #fff;
    border-radius: 9px;
    margin-top: 18vh;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 5vw;
      height: 5vw;
      border-radius: 50%;
      box-shadow: 1px 1px 1px 1px #cdcbcb;
    }
    h1 {
      font-size: 1vw;
      font-weight: bolder;
      margin: 2vh 0;
    }
    .comfirm-btn {
      width: 20vw;
      background-color: var(--bind-color);
      border-color: var(--bind-color);
      color: #fff;
    }
  }
}
/deep/ .el-input-group__append,
.el-input-group__prepend {
  background-color: var(--bind-color);
  border-color: var(--bind-color);
}
</style>


// WEBPACK FOOTER //
// pages/auth/binding/bind.vue